module.exports = __webpack_public_path__ + "img/settings-cover.adc3022f.png";